import React, { useEffect, useState, useRef } from "react";
import Field from '/src/components/UI/Field/Field';
import "./DashboardVariableFormModal.css"
import CheckBox from "/src/components/UI/CheckBox/CheckBox";
import TextArea from "/src/components/UI/TextField/TextArea";
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';

const DashboardVariableFormButtonSection = ({ setValue, watch, register,getValues }) => {
    return (
        <>
            <>
                <div className="checkbox_dashboard_variable_container checkbox_without_margin">
                    <Field label={"Enable Message Popup"} listLabelClassName="field-modal" />
                    <div style={{ marginRight: "100px" }}>
                        <CheckBox  {...register('enable_message_popup')} onChange={() => setValue("enable_message_popup", !getValues("enable_message_popup"))} checked={getValues("enable_message_popup")}></CheckBox>
                    </div>
                </div>
                <div className="title_container">
                    <Field label={<span>Confirmation Message Popup {(watch('enable_message_popup') == 0 ? <span className="disabled_field_message">Disabled</span> : "")}</span>} listLabelClassName="field-modal" />
                    <TextArea  {...register('message_popup')} placeholder="Enter the message you want have when you'll click on button" disabled={watch('enable_message_popup') == 1 ? false : true} className={"input full-width resize-area text_area_dashboard_form_variable " + (watch('enable_message_popup') == 1 ? "" : "text_area_disabled")}></TextArea>
                </div>

                <div className="checkbox_dashboard_variable_container checkbox_without_margin">
                    <Field label={"Enable Response Popup"} listLabelClassName="field-modal" />
                    <div style={{ marginRight: "100px" }}>
                        <CheckBox  {...register('enable_response_popup')} onChange={() => setValue("enable_response_popup", !getValues("enable_response_popup"))} checked={getValues("enable_response_popup")}></CheckBox>
                    </div>
                </div>
                <div className="title_container">
                    <Field label={<span>Response Message Popup {(watch('enable_response_popup') == 0 ? <span className="disabled_field_message">Disabled</span> : "")}</span>} listLabelClassName="field-modal" />
                    <TextArea  {...register('response_popup')} placeholder="Enter the message you want have when you'll click on button" disabled={watch('enable_response_popup') == 1 ? false : true} className={"input full-width resize-area text_area_dashboard_form_variable " + (watch('enable_response_popup') == 1 ? "" : "text_area_disabled")}></TextArea>
                </div>

            </>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="dashboard_advanced_parameters" onClick={() => ScrollIntoSlide("obligatory")}> <i className="fas fa-arrow-left" style={{ marginRight: "10px" }}></i>Main Parameters</div>
                <div className="dashboard_advanced_parameters" onClick={() => ScrollIntoSlide("advanced")}> Advanced Parameters <i className="fas fa-arrow-right" style={{ marginRight: "10px" }}></i></div>

            </div>

        </>
    )
}
export default DashboardVariableFormButtonSection;